export default __webpack_public_path__ + "static/media/zenbook.923fa41e.png";